import { DatePicker, Form, FormInstance, Row } from "antd";
import { useCallback, useState } from "react";
import { DATE_FORMAT } from "../../../../lib/constants";
import { CheckOutlined, CloseOutlined, EditOutlined } from "@ant-design/icons";
import { Dayjs } from "dayjs";

type BatchDateInputProps = {
  form: FormInstance;
  value: Dayjs;
  setBatchDateError: React.Dispatch<React.SetStateAction<string>>;
};

export const BatchDateInput = ({
  form,
  value,
  setBatchDateError,
}: BatchDateInputProps) => {
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const displayDate = Form.useWatch("batchDate", form);

  const onValueClicked = useCallback(() => setIsEdit(true), []);

  const onChange = useCallback(
    () => setBatchDateError(""),
    [setBatchDateError],
  );

  const onSave = useCallback(() => setIsEdit(false), []);

  const onCloseEdit = useCallback(() => {
    form.setFieldValue("batchDate", value);
    setIsEdit(false);
  }, [form, value]);

  return (
    <Row className="align-center batch-prop ml-6 mb-6 editable">
      <p className="my-0 text-md title w-500">Batch Date: </p>
      <Row
        className={`align-center value ${isEdit ? "d-none" : ""}`}
        onClick={onValueClicked}
      >
        <p className="my-0 px-1 text-md title w-500">
          {displayDate?.format(DATE_FORMAT)}
        </p>
        <EditOutlined className="ml-1" />
      </Row>
      <Row
        className={`w-100 batch-datapicker align-center position-absolute ${
          !isEdit ? "d-none" : ""
        }`}
      >
        <Row className="w-100">
          <Form.Item name="batchDate" className="mb-0">
            <DatePicker
              size="small"
              className="ml-1"
              format={DATE_FORMAT}
              onChange={onChange}
              allowClear={false}
            />
          </Form.Item>
          <CheckOutlined
            className="ml-2 ant-btn-link logo-cursor"
            onClick={onSave}
          />
          <CloseOutlined
            className="ml-2 ant-btn-link logo-cursor"
            onClick={onCloseEdit}
          />
        </Row>
      </Row>
    </Row>
  );
};
